export default __webpack_public_path__ + "static/media/trash-purple.34ea3d92.svg";